import { MenuItem } from './menu.item.model';

export const items: MenuItem[] = [
  {
    icon: 'home',
    name: 'nav.home',
    route: '/home',
  },
  {
    icon: 'business',
    name: 'nav.sites',
    route: '/worker/sites',
  },
  {
    icon: 'document',
    name: 'sites.tickets',
    route: '/worker/tickets',
  },
  {
    icon: 'newspaper',
    name: 'nav.news',
    route: '/worker/messages',
  },
];

export const residentMenu = {
  items,
};
